export function createApi(httpClient) {
  function getEmailCount(email) {
    return httpClient.post("carlead/count/email", {
      email
    });
  }
  return {
    getEmailCount
  };
}